import { Helmet } from "react-helmet";
import Cooperate from "../../components/cooperate";
import Header from "./header";
import Integration from "./integration";
import Models from "./models";
import Platform from "./platform";

export default function Advertisers() {
    
    return (
        <>
            <Helmet><title>Pixad - Advertisers</title></Helmet>
            <Header />
            <Platform />
            <Integration />
            <Models />
            <Cooperate />
        </>
    )
}